var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bige cont cgu", staticStyle: { "padding-top": "150px" } },
    [
      _c("h1", [_vm._v("Politique de Confidentialité")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _c("article", [
        _c("h2", [
          _vm._v(
            "\n      6. Collectons-nous des Données Personnelles sur des mineurs de moins de\n      16 ans ?\n    "
          )
        ]),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm._v(
              "\n      Notamment lors de votre adhésion à notre programme de fidélité et\n      conformément aux CGU\n      "
            ),
            _c(
              "router-link",
              {
                attrs: {
                  to: "/CGU",
                  target: "_self",
                  name:
                    "conditions générales d'utilisation de l'application idtroc",
                  rel: "tag"
                }
              },
              [_vm._v("\n        cliquez ici\n      ")]
            ),
            _vm._v(
              "\n      nous sommes amenés à collecter des Données Personnelles relatives à des\n      enfants de moins de 16 ans. A ce titre, l’adhérent s’engage à être\n      titulaire de l’autorité parentale de ce dernier.\n    "
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _vm._m(9),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _vm._m(12),
      _vm._v(" "),
      _vm._m(13)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("details", { attrs: { open: "" } }, [
      _c("summary", [
        _c("h2", { staticClass: "inline" }, [_vm._v("SOMMAIRE :")])
      ]),
      _vm._v(" "),
      _c("ol", [
        _c("li", [_vm._v("Définitions")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        Qui est le Responsable de traitement de vos Données Personnelles ?\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Où collectons-nous vos Données Personnelles ?")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        Quelles sont les catégories de Données Personnelles que nous\n        traitons ?\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        Quelles sont les Données Personnelles que nous traitons et les\n        finalités associées ?\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        Collectons-nous des Données Personnelles sur des mineurs de moins de\n        16 ans ?\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Qui sont les destinataires de vos Données Personnelles ?")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        Vos Données Personnelles sont-elles transférées hors de l’Union\n        Européenne ?\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        Quelle est la durée de conservation de vos Données Personnelles ?\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        Quelles sont les mesures de sécurité appliquées sur vos Données\n        Personnelles ?\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Quels sont vos droits sur vos Données Personnelles ?")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Comment exercer vos droits sur vos Données Personnelles ?")
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("Comment contacter notre Data Protection Officer ?")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Mise à jour de notre politique sur les Données Personnelles ?"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [_vm._v("1. Définitions :")]),
      _vm._v(" "),
      _c("table", { attrs: { "aria-label": "Définitions" } }, [
        _c("colgroup", [
          _c("col", { staticStyle: { width: "30%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "70%" } })
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v(
                "\n            Qu’est-ce qu’une « Donnée Personnelle » ?\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            C’est toute information se rapportant à une personne physique\n            identifiée ou identifiable. Est réputée être une personne physique\n            identifiable, une personne physique qui peut être identifiée,\n            directement ou indirectement, notamment par référence à un\n            identifiant, tel qu’un nom, un numéro d’identification, des\n            données de géolocalisation, un identifiant en ligne, ou à un ou\n            plusieurs éléments spécifiques propres à son identité physique,\n            physiologique, génétique, psychique, économique, culturelle ou\n            sociale.\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v(
                "\n            Qu’est-ce qu’un « Traitement de Données Personnelles » ?\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            C’est toute opération ou tout ensemble d’opérations effectuées ou\n            non à l’aide de procédés automatisés et appliquées à des données\n            ou des ensembles de données à caractère personnel, telles que la\n            collecte, l’enregistrement, l’organisation, la structuration, la\n            conservation, l’adaptation ou la modification, l’extraction, la\n            consultation, l’utilisation, la communication par transmission, la\n            diffusion ou toute autre forme de mise à disposition, le\n            rapprochement ou l’interconnexion, la limitation, l’effacement ou\n            la destruction.\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v(
                "\n            Qu’est-ce qu’un « Responsable de Traitement » ?\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            C’est la personne physique ou morale, l’autorité publique, le\n            service ou un autre organisme qui, seul ou conjointement avec\n            d’autres, détermine les finalités et les moyens de traitement.\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("Qu’est-ce qu’un « Sous-traitant » ?")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            C’est la personne physique ou morale qui traite des données à\n            caractère personnel pour le compte du responsable du traitement.\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("Qu’est-ce qu’un « Consentement » ?")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            C’est toute manifestation de volonté, libre, spécifique, éclairée\n            et univoque par laquelle la personne concernée accepte, par une\n            déclaration ou par un acte positif clair, que des données\n            personnelles la concernant fassent l’objet d’un traitement.\n          "
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v(
          "\n      2. Qui est le Responsable de Traitement de vos Données Personnelles ?\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      OKAIDI SAS au capital de 6 483 008, 00 euros, immatriculée au RCS de Lille\n      sous le n°398 110 445, dont le siège social est situé au 162 boulevard\n      de Fourmies, à Roubaix (59000), représentée par Grégoire DUFOREST en sa\n      qualité de Directeur Général.\n      "
        ),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Ce sont elles qui déterminent les finalités et les moyens des\n      traitements définis ci-après.\n    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v("\n      3. Où collectons-nous vos Données Personnelles ?\n    ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Vos données personnelles pourront être collectées lors de votre\n      navigation sur l’Application.\n    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v(
          "\n      4. Quelles sont les catégories de Données Personnelles que nous\n      traitons ?\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Le tableau ci-dessous identifie les principales catégories de Données\n      Personnelles que nous sommes amenés à traiter vous concernant :\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "table",
        { attrs: { "aria-label": "Catégories de Données Personnelles" } },
        [
          _c("colgroup", [
            _c("col", { staticStyle: { width: "30%" } }),
            _vm._v(" "),
            _c("col", { staticStyle: { width: "70%" } })
          ]),
          _vm._v(" "),
          _c("thead", [
            _c("tr", [
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("Catégories de données")
              ]),
              _vm._v(" "),
              _c("th", { attrs: { scope: "col" } }, [
                _vm._v("Description de la catégorie")
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tbody", [
            _c("tr", [
              _c("th", { staticClass: "no-bg", attrs: { scope: "col" } }, [
                _vm._v("Données du Compte Client")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            Il s’agit des données nécessaires à la création du compte client\n            et des données que vous pouvez décider de fournir pour bénéficier\n            d’une expérience personnalisée sur notre Application.\n            "
                ),
                _c("ul", [
                  _c("li", [
                    _vm._v(
                      "\n                Ces données comprennent notamment : adresse e-mail, prénom,\n                nom, adresse postale, le numéro de pièce d’identité, la date\n                de délivrance de la pièce d’identité, l’autorité ayant délivré\n                la pièce d’identité et sa date d’expiration.\n              "
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { staticClass: "no-bg", attrs: { scope: "col" } }, [
                _vm._v("Données du Compte Fidélité")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            Il s’agit de données associées à votre compte fidélité vous\n            permettant d’utiliser les services de l’Application IDTROC.\n            "
                ),
                _c("br"),
                _vm._v(
                  "Il peut par exemple s’agir de : nom, prénom, adresse e-mail\n            et adresse postale du titulaire du compte fidélité, achats\n            réalisés, nombre de points de fidélité, date de souscription au\n            compte fidélité, et éventuellement le prénom et la date de\n            naissance de vos enfants.\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", { staticClass: "no-bg", attrs: { scope: "col" } }, [
                _vm._v("Données de Géolocalisation")
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  "\n            Il s’agit des données concernant votre position géographique à un\n            moment précis. Cela permettra à l’Application de rechercher les\n            boutiques proposant des événements IDTROC le plus proche de chez\n            vous.\n          "
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Parmi les Données Personnelles collectées, certaines sont mentionnées\n      avec un astérisque afin de préciser le caractère obligatoire de la\n      collecte.\n    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v(
          "\n      5. Quelles sont les Données Personnelles que nous traitons et les\n      finalités associées ?\n    "
        )
      ]),
      _vm._v(" "),
      _c("table", { attrs: { "aria-label": "Données Personnelles" } }, [
        _c("thead", [
          _c("tr", [
            _c("th", [
              _vm._v(
                "\n            Pour quelles raisons collectons-nous vos Données Personnelles ?\n          "
              )
            ]),
            _vm._v(" "),
            _c("th", [
              _vm._v(
                "\n            Quelles sont les catégories de données concernées par ce\n            traitement ?\n          "
              )
            ]),
            _vm._v(" "),
            _c("th", [
              _vm._v(
                "\n            Sur quelle base juridique se fonde le traitement de vos Données\n            Personnelles ?\n          "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [
              _c("ul", [
                _c("li", [_vm._v("Créer et gérer votre compte client")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                Personnaliser votre expérience client sur notre site\n              "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n            Données du Compte Client\n          ")
            ]),
            _vm._v(" "),
            _c("td", [
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "\n                Consentement lorsque vous créez votre compte sans effectuer de\n                dépôt et pour les données qui ne sont pas strictement\n                nécessaires à l’exécution du contrat\n              "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                Exécution du contrat de dépôt\n              "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v("Gérer, suivre et traiter votre dépôt sur l’Application")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("Données du compte client, données de géolocalisation")
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Exécution du contrat de dépôt")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v(
                "\n            Gérer et suivre votre adhésion au programme fidélité, vous\n            permettant de bénéficier des services de l’Application IDTROC\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n            Données du Compte Fidélité\n          ")
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("\n            Consentement\n          ")])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v(
                "\n            Vous géolocaliser afin de vous indiquer la boutique la plus proche\n            de votre position géographique pour vous inscrire à un événément\n            IDTROC et effectuer un dépôt\n          "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n            Données de Géolocalisation\n          ")
            ]),
            _vm._v(" "),
            _c("td", [_c("ul", [_c("li", [_vm._v("Consentement")])])])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("Lutter contre la Fraude")]),
            _vm._v(" "),
            _c("td", [_vm._v("Données du Compte Client, Données de Fidélité")]),
            _vm._v(" "),
            _c("td", [
              _c("ul", [
                _c("li", [
                  _vm._v("Intérêt légitime du responsable de traitement")
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [
              _vm._v(
                "\n          Gérer et identifier tous les articles qui ont donné lieu à une transaction dans le cadre du dépôt-vente\n        "
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Données du registre de brocante")]),
            _vm._v(" "),
            _c("td", [_c("ul", [_c("li", [_vm._v("Obligation légale")])])])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v("7. Qui sont les destinataires de vos Données Personnelles ?")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      OKAIDI SAS ne transmettra vos Données Personnelles à des tiers à des\n      fins de prospection que si vous avez donné votre accord à ce titre.\n    "
        )
      ]),
      _vm._v(" "),
      _c("table", { attrs: { "aria-label": "Destinataires" } }, [
        _c("colgroup", [
          _c("col", { staticStyle: { width: "50%" } }),
          _vm._v(" "),
          _c("col", { staticStyle: { width: "50%" } })
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("Destinataires internes")
            ]),
            _vm._v(" "),
            _c("td", [
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "\n                Partenaires commerciaux : marques appartenant à la communauté\n                des marques IDKIDS GROUP, à savoir : Okaidi, Obaibi, Oxybul\n                éveil et jeux, Idkids, Jacadi, N’Joy, Rigolo Comme La Vie,\n                Bubblemag, Idtroc, Catimini, Absorba\n              "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                Personnels habilités des services suivants : commercial,\n                communication, marketing, informatique, ressources humaines,\n                innovation, fond d’action\n              "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("Destinataires externes")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n            Le personnel habilité des :\n            "),
              _c("ul", [
                _c("li", [
                  _vm._v("\n                Prestataires\n              ")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "\n                Sous-traitants, dans le cadre des missions suivantes : gestion\n                du service-client, traitement et gestion des dépôts effectués\n                sur l’Application, la détection et la prévention des fraudes.\n                Les sous-traitants agissent uniquement pour notre compte et\n                sur nos instructions.\n              "
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v(
          "\n      8. Vos Données Personnelles sont-elles transférées hors de l’Union\n      Européenne ?\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Les serveurs hébergeant vos données personnelles sont situés en Europe\n      Centrale.\n    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v(
          "\n      9. Quelle est la durée de conservation de vos Données Personnelles ?\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Vous trouverez ci-dessous les durées de conservation correspondantes à\n      la liste des principaux traitements de données :\n    "
        )
      ]),
      _vm._v(" "),
      _c("table", { attrs: { "aria-label": "Durée de conservation" } }, [
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("\n            Catégorie de données\n          ")
            ]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [
              _vm._v("\n            Durée de conservation\n          ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", { staticClass: "no-bg", attrs: { scope: "col" } }, [
              _vm._v("\n            Données du Compte Client\n            "),
              _c("br"),
              _vm._v("Données de Fidélité\n          ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n            Durée d’ouverture du compte client /du compte fidélité et 5 ans en\n            archive à compter de la suppression du compte\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg", attrs: { scope: "col" } }, [
              _vm._v("\n            Données de Géolocalisation\n          ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("1 mois à compter de l’enregistrement de la donnée")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v(
          "\n      10. Quelles sont les mesures de sécurité appliquées sur vos Données\n      Personnelles ?\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      OKAIDI SAS en tant que Responsable du traitement de vos Données\n      Personnelles, s’engage à prendre les mesures nécessaires pour assurer la\n      sécurité et la confidentialité des données personnelles transmises, et\n      ce dans le respect des dispositions légales en vigueur.\n    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v("11. Quels sont vos droits sur vos Données Personnelles ?")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Conformément au Règlement Européen 2016/679 du 27 avril 2016 sur la\n      protection des Données Personnelles, vous bénéficiez des droits\n      suivants :\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "table",
        { attrs: { "aria-label": "Droits sur vos Données Personnelles" } },
        [
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("\n          Droit d’accès\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          Vous avez le droit d’obtenir l’accès à l’ensemble des données\n          personnelles qui vous concernent. Une copie de ces dernières vous\n          sera alors transmise.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("\n          Droit de rectification\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          Vous avez le droit d’obtenir la rectification de vos données\n          personnelles, si ces dernières sont inexactes, incomplètes ou\n          nécessitent une mise à jour.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("\n          Droit d’opposition\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          Vous avez le droit de vous opposer, à tout moment, à un traitement\n          de données personnelles, sauf si celui-ci correspond à une\n          obligation légale.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("\n          Droit d’effacement\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          Vous avez le droit d’obtenir l’effacement de l’ensemble de vos\n          données personnelles.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("\n          Droit de portabilité\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          Vous avez le droit de recevoir les données personnelles vous\n          concernant dans un format structuré, couramment utilisé et lisible\n          par machine. Vous avez également le droit d’exiger la transmission\n          de vos données personnelles directement à un autre responsable de\n          traitement, lorsque cela est réalisable techniquement.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v("\n          Droit de limitation\n        ")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          Vous avez le droit d’obtenir la limitation du traitement, notamment\n          si vous contestez l’exactitude des données personnelles que nous\n          traitons sur vous.\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "no-bg" }, [
              _vm._v(
                "\n          Droit d’édiction des directives anticipées\n        "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n          Vous disposez de la possibilité d’indiquer vos directives quant au\n          sort de vos données personnelles après votre décès. Pour cela, il\n          vous suffit de nous adresser vos volontés (conservation, effacement,\n          ou autres volontés spécifiques).\n        "
              )
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v(
          "\n      12. Comment exercer vos droits sur vos Données Personnelles ?\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Vous pouvez exercer vos droits par les moyens suivants :\n    "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n        Par voie postale, en écrivant à OKAIDI – Service clients - 162\n        boulevard de Fourmies– 59100 ROUBAIX- France.\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        En ligne : en utilisant le formulaire de contact à votre disposition\n        "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.okaidi.fr/contactus",
                title: "formulaire de contact"
              }
            },
            [_vm._v("\n          cliquez ici\n        ")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Veuillez noter que, dans le cadre de l’exercice des droits par les\n      demandeurs, notre Service Client pourra être amené à vérifier l’identité\n      desdits demandeurs, en requérant possiblement la copie d’une pièce\n      d’identité en cours de validité.\n      "
        ),
        _c("br"),
        _vm._v(
          "Pour faciliter le traitement de votre demande, il est conseillé de\n      nous préciser votre nom, prénom, ainsi que votre adresse email et, si\n      vous en disposez, votre numéro de fidélité. "
        ),
        _c("br"),
        _vm._v(
          "OKAIDI SAS s’engage à\n      vous adresser une réponse dans un délai maximum d’un mois à compter de\n      la date d’exercice de votre droit. "
        ),
        _c("br"),
        _vm._v(
          "Par ailleurs, pour faciliter\n      l’accès à vos droits :\n    "
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "\n        Chaque newsletter envoyée par OKAIDI SAS, vous propose un lien de\n        désabonnement, vous permettant en un clic, de vous désabonner\n        facilement des newsletters et actualités des marques de la société\n        OKAIDI SAS et /ou de leurs Partenaires le cas échéant ;\n      "
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Chaque SMS envoyé par OKAIDI SAS vous propose un « STOP SMS » ;"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n        Vous pouvez également gérer vos préférences en matière de prospection\n        commerciale directement en vous connectant votre compte web, au sein\n        de la rubrique « Mes newsletters et alertes ».\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Enfin, nous vous rappelons que vous avez la possibilité de saisir à tout\n      moment la Commission Nationale Informatiques & Libertés (CNIL) :\n      "
        ),
        _c("a", { attrs: { href: "https://www.cnil.fr/fr/agir" } }, [
          _vm._v("https://www.cnil.fr/fr/agir")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v("13. Comment contacter notre Data Protection Officer ?")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Nous vous informons OKAIDI SAS a nommé un DPO, que vous pouvez contacter\n      à tout moment de la façon suivante :\n    "
        )
      ]),
      _vm._v(" "),
      _c("address", [
        _vm._v(
          "\n      Par voie postale, en écrivant à l’adresse suivante : OKAIDI – Service\n      clients - 162 boulevard de Fourmies– 59100 ROUBAIX- France, ou en\n      utilisant le formulaire de contact\n      "
        ),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.okaidi.fr/contactus",
              title: "formulaire de contact"
            }
          },
          [_vm._v("\n        cliquez ici\n      ")]
        ),
        _vm._v(
          "\n      en choisissant pour objet la section « Protection de mes Données\n      Personnelles »\n    "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("article", [
      _c("h2", [
        _vm._v(
          "14. Mise à jour de notre Politique sur les Données Personnelles"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      OKAIDI SAS peut être amenée à modifier occasionnellement cette politique\n      sur les Données Personnelles. Cette modification sera rendue visible par\n      la dernière date de mise à jour présente en haut de la présente\n      rubrique.\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b2df9dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b2df9dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Confidentialite.vue
// module id = null
// module chunks = 